<template>
  <div class="box">
    <div class="content">
      <div class="no_club">
        <div style="height: 3.56rem"></div>
        <div class="create_btn" @click="toClub">立即创建</div>
      </div>
      <div class="no_grade" style="margin-top: 0.3rem">
        <div style="height: 3.56rem"></div>
        <div class="create_btn" @click="toKaoji">立即创建</div>
      </div>
    </div>
    <van-dialog
      v-model="clubShow"
      title=""
      class="dialog-box"
      :showConfirmButton="false"
    >
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <!-- <div class="dialog-step-li">
          1.首次申请，默认成为一星俱乐部，如需升级星级详见俱乐部申报流程；
        </div>

        <div class="dialog-step-li">2.俱乐部升级类别</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）二星俱乐部</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）三星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）四星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）五星俱乐部</div>
          </li>
        </ul> -->

        <!--        <div class="dialog-step-li">3.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>-->
        <div class="dialog-step-li">
          附件下载
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')">-->
          <!--            啦啦操星级俱乐部管理办法-->
          <!--          </div>-->
          <div>
            <van-button
              type="primary"
              @click="
                download(
                  '啦啦操星级俱乐部管理办法',
                  'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf'
                )
              "
            >
              啦啦操星级俱乐部管理办法
            </van-button>
          </div>
        </div>

        <van-button type="primary" size="large" @click="toClubNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="clubShow = false"
          >我再想想</van-button
        >
      </div>
    </van-dialog>
    <van-dialog
      v-model="kaojiShow"
      title=""
      class="dialog-box"
      :showConfirmButton="false"
    >
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <div class="dialog-step-li">1.可创建类型为：</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）七彩星级指定考级点</div>
            <div class="li-right">0元</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）七彩星级指定样板考级点</div>
            <div class="li-right">9800元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）七彩星级指定考级中心</div>
            <div class="li-right">120000元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）七彩星级指定样板考级中心</div>
            <div class="li-right">135000元</div>
          </li>
        </ul>

        <div class="dialog-step-li">
          2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/
        </div>

        <div class="dialog-step-li">
          3.附件下载
          <div
            class="dialog-step-li-text"
            @click="
              download(
                '啦啦操七彩星级管理办法',
                'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf'
              )
            "
          >
            啦啦操七彩星级管理办法
          </div>
          <div
            class="dialog-step-li-text"
            @click="
              download(
                '七彩星级考级中心（点）加盟方案',
                'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf'
              )
            "
          >
            七彩星级考级中心（点）加盟方案
          </div>
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('考级点文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip')">-->
          <!--            考级点文化包（兼容版）请下载制作-->
          <!--          </div>-->
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('考级中心文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip')">-->
          <!--            考级中心文化包（兼容版）请下载制作-->
          <!--          </div>-->
        </div>

        <van-button type="primary" size="large" @click="toKaojiNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="kaojiShow = false"
          >我再想想</van-button
        >
      </div>
    </van-dialog>
  </div>
</template>
<style scoped>
.box {
  height: 100vh;
  background: #f0eff4;
}
.content {
  padding: 0.2rem;
  padding-top: 0.3rem;
}
.no_club {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarujulebu@2x.png");
  background-size: 100% 100%;
}
.create_btn {
  width: 86px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
}
.no_grade {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarukaoji@2x.png");
  background-size: 100% 100%;
}
.dialog-head {
  font-size: .5rem;
  font-weight: 700;
  text-align: center;
  padding: .4rem 0 .3rem;
}

.dialog-content {
  padding: 0 .3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: .2rem 0 .3rem;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Dialog)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "ClubIndex",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      loading: false,
      clubShow: false,
      kaojiShow: false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      row: {
        danwei: {},
        exame_center: {},
        club: {},
      },
      formData: {},
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "我的俱乐部";
    this.fetch();
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/user/certindexOwn",
        {},
        (res) => {
          that.row = res.data;
          that.loading = true;
        },
        (res) => {
          that.loading = true;
          console.log("errrrrr");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    toClub() {
      this.clubShow = true;
    },

    toKaoji() {
      this.kaojiShow = true;
    },

    // 官网已有考级中心认证
    toAuth() {
      rbLink({
        name: "QcxjStationBind",
      });
    },

    // 创建俱乐部
    toClubNext(id) {
      // rbLink({
      //   name: "ClubApplyMine",
      //   query: {
      //     id: id,
      //   },
      // });
    },

    // 创建考级中心/点
    toKaojiNext(id) {
      rbLink({
        name: "QcxjStationApplyMine",
        query: {
          id: id,
        },
      });
    },

    // 下载附件
    download(name, url) {
      appEvent({
        name: "downloadFile",
        query: {
          name: name,
          url: url,
        },
      });
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// NoMyClub.vue?7e2d82f9